import React, { Suspense } from 'react';
import { getRolePermissions } from '../permissions';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import NotFound from '../components/NotFound';
import GoogleAnalyticsTracker from 'GoogleAnalyticsTracker';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

const withRoleRoutes = WrappedComponent => {
    return props => {
        const rolePermissions = getRolePermissions(props.role, props.enableProductAssistant, props.enableInsights);
        let routes;
        if (Array.isArray(rolePermissions) && rolePermissions.length) {
            routes = rolePermissions.filter(rp => rp.route).map(rp => rp.route)
        }

        return (
            <Router>
                <GoogleAnalyticsTracker />
                <WrappedComponent {...props} >
                    <Suspense fallback={
                        <Box display="flex" justifyContent="center" alignItems="center" height="100%" minHeight="200px">
                            <CircularProgress />
                        </Box>
                    }>
                        <Switch>
                            {
                                routes.map(route => {
                                    return (
                                        <Route path={route.path} exact={route.exact} component={route.component} key={route.path} />
                                    );
                                })
                            }
                            <Route path="/404" component={NotFound} />
                            <Route component={NotFound} />
                        </Switch>
                    </Suspense>
                </WrappedComponent>
            </Router>
        );
    }
};

export default withRoleRoutes;
